import * as React from 'react';
import styled from 'styled-components';
import { color, space } from '@core-ds/primitives';
import { Bullet } from '@core-ds/icons/16';
import withTippy from './with_tippy';
import type { TippyProps } from '@tippyjs/react';

const Container = styled.div`
   margin: 0 ${space[3]};

   &:last-child {
      margin-right: 0;
   }
`;

const UnstyledButton = styled.a`
   display: inline-block;
   position: relative;
   cursor: pointer;
   overflow: visible;

   svg:first-child {
      transition: color 0.1s;
   }

   :hover {
      text-decoration: none;
      svg:first-child {
         color: ${color.white};
      }

      > div {
         background-color: ${color.white};
      }
   }
`;

const Badge = styled(Bullet)`
   position: absolute;
   top: -8px;
   right: -10px;

   color: ${color.blue.ifixit};
`;

// @ts-expect-error TS(2345) FIXME: Argument of type 'StyledComponent<"a", any, {}, ne... Remove this comment to see the full error message
const UnstyledButtonWithTippy = withTippy(UnstyledButton);

type DropdownProps = Omit<TippyProps, 'children' | 'content'> & {
   id?: string;
   icon: React.ReactNode;
   hasBadge?: boolean;
   label: string;
   children: TippyProps['content'];
};

const Dropdown = ({ id, children, icon, hasBadge, label, ...tippyOptions }: DropdownProps) => {
   const passthroughProps = {
      'aria-label': label,
      role: 'button',
   };
   return (
      <Container>
         <UnstyledButtonWithTippy
            id={id}
            content={children}
            clickableElementProps={passthroughProps}
            {...tippyOptions}
         >
            {icon}
            {!!hasBadge && <Badge className="headerBadge" />}
         </UnstyledButtonWithTippy>
      </Container>
   );
};

Dropdown.defaultProps = {
   /* eslint-disable-next-line @typescript-eslint/no-empty-function */
   onMount: () => {},
};

export default Dropdown;
